import type { DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetAuthorBasicInfo } from './discoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetAuthorBasicInfo';
import type { DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetAuthorSocial } from './discoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetAuthorSocial';

/**
 * 트윗 작성자 정보
 */
export type DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetAuthor = {
  /** 사용자 기본 정보 */
  basicInfo: DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetAuthorBasicInfo;
  /** 소셜 관계 정보 */
  social?: DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetAuthorSocial;
};
